import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Modal } from "react-bootstrap";
import moment from "moment";

const LeaveModal = ({ modal_type, modalstatus, setModalstatus, handleClose, getLeaveList, leave_id }) => {
    var currYearName = moment().format('Y');
    let SERVER_URL = process.env.REACT_APP_API_URL;
    let token = JSON.parse(localStorage.getItem('key'));
    const userId = localStorage.getItem('userId');
    const [leaveType, setLeaveType] = useState("");
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [duration, setDuration] = useState("");
    const [halfDay, setHalfDay] = useState("");
    const [reason, setReason] = useState("");
    const [errorMessages, setErrorMessages] = useState({});
    const [dateSelect, setDateSelect] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [btnDisable, setBtnDisable] = useState(false);
    const [successMsg, setSuccessMsg] = useState('');
    const [err, setErr] = useState('')
    const [leaveId, setLeaveId] = useState('')

    const handleClose2 = () => {
        setBtnDisable(false)
        setIsSubmitting(false)
        setLeaveId('')
        setErr('')
        setSuccessMsg('')
        setErrorMessages({})
        setDateSelect('')
        setReason('')
        setHalfDay('')
        setDuration('')
        setToDate(null)
        setFromDate(null)
        setLeaveType('')
        setModalstatus(false)
    }
    const filterToDate = (date) => {
        return fromDate ? moment(date).isSameOrAfter(moment(fromDate)) : true;
    };
    const validateForm = () => {
        const errors = {};
        if (!leaveType) errors.leaveType = " is required.";
        if (!duration) errors.duration = "Duration is required.";
        if (duration === "2" && !halfDay) errors.halfDay = "Half-day selection is required.";
        if (!fromDate) errors.fromDate = "From date is required.";
        if (!toDate) errors.toDate = "To date is required.";
        if (new Date(toDate) < new Date(fromDate)) errors.toDate = "To date must be after From date.";

        if (!reason.trim()) errors.reason = "Reason is required.";
        return errors;
    };
    const leaveFetch = () => {
        fetch(SERVER_URL + `api/leave/leave-edit`, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'authorization': `bearer ${token.value}`
            },
            body: JSON.stringify({
                leaveId: leave_id
            }),
        }).then(res => res.json())
            .then(data => {
                // console.log(data.data, 'edit-leave data=====::')
                if (data.status == true) {
                    setLeaveType(data.data?.leave_type)
                    setFromDate(moment(data.data?.from_date).format('yyyy-MM-DD'))
                    setToDate(moment(data.data?.to_date).format('yyyy-MM-DD'))
                    setReason(data.data?.user_remarks)
                    setDuration(data.data?.duration_type)
                    if (duration === 2) {
                        setHalfDay(data.data?.duration_day)
                    }
                    setLeaveId(data.data?.id)
                }
            })
    }
    // useEffect(() => {

    //     leaveFetch()

    // }, [leave_id])
    const handleSubmit = () => {
        const errors = validateForm();
        if (Object.keys(errors).length > 0) {
            setErrorMessages(errors);
            return;
        }
        setIsSubmitting(true);
        if (leave_id) {
            editLeave();
        } else {
            addLeave();
        }
        // Simulate form submission
        setTimeout(() => {
            //   console.log({
            //     leaveType,
            //     fromDate,
            //     toDate,
            //     duration,
            //     halfDay,
            //     reason,
            //   });
            setIsSubmitting(false);
            setModalstatus(false)
            handleClose2();
        }, 1000);
    };
    const checkLeaveBalance = async (TotalLeave, leaveType2) => {
        try {
            const response = await fetch(SERVER_URL + `api/leave/user-balance-leave`, {
                method: "POST", // or "GET" depending on your API
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({
                    TotalLeave: TotalLeave,
                    userId: userId,
                    leaveType: leaveType2,
                }),
            });

            if (!response.ok) {
                throw new Error(`Error: ${response.statusText}`);
            }

            const data = await response.json(); // Assuming the API returns JSON
            // console.log(data.leaveBalance, 'leave Balance ========::')
            // console.log(TotalLeave, 'TotalLeave ========::')
            if (data.leaveBalance?.total_el_leave <= TotalLeave && leaveType === "1") {
                //  alert('You have no balance leave in your account')
                setBtnDisable(true)
            } else if (data.leaveBalance?.total_cl_leave <= TotalLeave && leaveType === "2") {
                //  alert('You have no balance leave in your account')
                setBtnDisable(true)
            } else if (data.leaveBalance?.total_sl_leave <= TotalLeave && leaveType === "3") {
                // alert('You have no balance leave in your account')
                setBtnDisable(true)
            } else {
                setBtnDisable(false)

                return data.leaveBalance;
            }
            // Return the leave balance (adjust based on your API response structure)
        } catch (error) {
            console.error("Failed to fetch leave balance:", error);
            return null; // Handle the error gracefully
        }
    };
    const checkLeaveDurationBalance = async (TotalLeave, leaveType2, durationType) => {

    };
    const handleDuration = (e) => {
        const value = e.target.value;
        // console.log(value,'value')
        if (value) {
            setDuration(value);

            calculateTotalFullDays(fromDate, toDate, value)
        }

    }
    const calculateTotalFullDays = async (from, to, durationType) => {
        let diff2;
        if (from && to) {
            diff2 = Math.ceil((new Date(to) - new Date(from)) / (1000 * 60 * 60 * 24)) + 1;
            try {
                const response = await fetch(SERVER_URL + `api/leave/user-balance-leave`, {
                    method: "POST", // or "GET" depending on your API
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'authorization': `bearer ${token.value}`
                    },
                    body: JSON.stringify({
                        TotalLeave: diff2,
                        userId: userId,
                        leaveType: leaveType,
                    }),
                });

                if (!response.ok) {
                    throw new Error(`Error: ${response.statusText}`);
                }

                const data = await response.json(); // Assuming the API returns JSON
                // console.log(data.leaveBalance, 'leave Balance ========::')
                // console.log(diff2, 'TotalLeave ========::')
                // console.log(duration, 'durationType ========::')
                // console.log(leaveType, 'leaveType ========::')
                let halfTotal;
                if (durationType === 2) {
                    halfTotal = '0.5';
                }
                if (data.leaveBalance?.total_el_leave < diff2 && leaveType === "1" && durationType === '1') {
                    // alert('You have no balance leave in your account EL')
                    setBtnDisable(true)
                } else if (data.leaveBalance?.total_el_leave === 0 && leaveType === "1" && (durationType === '2' || durationType === '1')) {
                    // alert('You have no balance leave in your account 0.5 EL ')
                    setBtnDisable(true)
                } else if (data.leaveBalance?.total_cl_leave < diff2 && leaveType === "2" && durationType === '1') {
                    //  alert('You have no balance leave in your account CL ')
                    setBtnDisable(true)
                } else if (data.leaveBalance?.total_cl_leave === 0 && leaveType === "2" && durationType === '2') {
                    // alert('You have no balance leave in your account 0.5 CL')
                    setBtnDisable(true)

                } else if (data.leaveBalance?.total_sl_leave < diff2 && leaveType === "3" && durationType === "1") {
                    // alert('You have no balance leave in your account SL')
                    setBtnDisable(true)
                } else if (data.leaveBalance?.total_sl_leave === 0 && leaveType === "3" && durationType === '2') {
                    // alert('You have no balance leave in your account 0.5 SL')
                    setBtnDisable(true)
                } else {
                    setBtnDisable(false)

                    return data.leaveBalance;
                }
                // Return the leave balance (adjust based on your API response structure)
            } catch (error) {
                console.error("Failed to fetch leave balance:", error);
                return null; // Handle the error gracefully
            }
            //await checkLeaveDurationBalance(diff2, leaveType, durationType)
            setDateSelect(diff2 > 0 ? diff2 : 0);
        }
    }
    // const calculateTotalDays = async (from, to) => {

    //     let diff;
    //     if (from && to) {
    //         diff = Math.ceil((new Date(to) - new Date(from)) / (1000 * 60 * 60 * 24)) + 1;
    //         await checkLeaveBalance(diff, leaveType, '')
    //         setDateSelect(diff > 0 ? diff : 0);
    //         //  if(duration === 1){
    //         //     await checkLeaveBalance(diff,leaveType)
    //         //     setDateSelect(diff > 0 ? diff : 0);
    //         // }else if(duration === 2 && halfDay === 1){
    //         //     await checkLeaveBalance(diff,leaveType)
    //         //     setDateSelect(diff > 0 ? diff : 0);
    //         // }else if(duration === 2 && halfDay === 2){
    //         //     await checkLeaveBalance('0.5',leaveType)
    //         //     setDateSelect(diff > 0 ? diff : 0);
    //         // }

    //     } else {
    //         setDateSelect("");
    //     }


    // };

const calculateTotalDays = async (from, to) => {
  if (from && to) {
    let start = new Date(from);
    let end = new Date(to);
    let diff = 0;

    // Loop through each day
    while (start <= end) {
      const day = start.getDay(); // 0 = Sunday, 6 = Saturday
      if (day !== 0 && day !== 6) {
        diff++;
      }
      start.setDate(start.getDate() + 1); // move to next day
    }

    await checkLeaveBalance(diff, leaveType, "");
    setDateSelect(diff > 0 ? diff : 0);
  } else {
    setDateSelect("");
  }
};

    const editLeave = () => {
        const response = fetch(SERVER_URL + `api/leave/leave-update`,
            {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({
                    leaveId: leaveId,
                    formDate: fromDate,
                    toDate: toDate,
                    requestType: 3,
                    leaveType: leaveType,
                    leaveDuration: duration,
                    durationDay: duration === 2 ? halfDay : 1,
                    description: reason,
                    requestedBy: userId

                }),
            }).then(res => res.json())
            .then(data => {
                if (data.status == true) {
                    setSuccessMsg('Leave successfully updated')
                    setErr('green')
                    getLeaveList(currYearName)
                    setTimeout(function () {
                        handleClose2()
                    }, 1000);
                }
            });
    }
    const addLeave = () => {
        const userId = localStorage.getItem('userId');
        const response = fetch(SERVER_URL + `api/leave/apply-leave`,
            {
                method: 'post',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({
                    EmpID: userId,
                    requestType: 3,
                    formDate: fromDate,
                    toDate: toDate,
                    leaveType: leaveType,
                    leaveDuration: duration,
                    durationDay: duration === 2 ? halfDay : 1,
                    description: reason
                }),
            }).then(res => res.json())
            .then(data => {
                if (data.status == true) {
                    setSuccessMsg(data.meassage ? data.meassage : '')
                    setErr('green')
                    getLeaveList(currYearName)
                    setTimeout(function () {
                        handleClose2()
                    }, 1000);
                }
            })
    }

    return (
        <Modal show={modalstatus} size="md" id="confirm_login">
            <div className="modal-body">
                <button
                    type="button"
                    className="float-end btn_close"
                    onClick={handleClose2}
                    data-bs-dismiss="modal"
                    aria-label="Close"
                >
                    <i className="icon icon-cross fw-bold"></i>
                </button>
                <div className="dash_white_box_ttl text-center">
                    {modal_type === "edit" ? "Edit Apply Leave" : "Apply Leave"}
                </div>

                <div className="mb-2">
                    <label className="col-form-label">
                        Leave Type:
                        <span style={{ color: "red" }}>{errorMessages.leaveType}</span>
                    </label>
                    <select
                        value={leaveType}
                        onChange={(e) => setLeaveType(e.target.value)}
                        className="form-select"
                    >
                        <option value="">Select Type</option>
                        <option value="1">Earned Leave</option>
                        <option value="2">Casual Leave</option>
                        <option value="3">Sick Leave</option>
                        <option value="4">Leave Without Pay</option>
                    </select>
                </div>

                <div className="mb-2">
                    <div className="row">
                        <div className="col-md-6 pr07">
                            <label className="col-form-label">
                                From Date:
                                <span style={{ color: "red" }}>{errorMessages.fromDate}</span>
                            </label>
                            <DatePicker
                                placeholderText="DD-MM-YYYY"
                                value={fromDate ? moment(fromDate).format("DD-MM-YYYY") : null}
                                onChange={(date) => {
                                    const formattedFromDate = moment(date).format("YYYY-MM-DD");
                                    setFromDate(formattedFromDate);
                                    setToDate(null)
                                    //calculateTotalDays(date, formattedFromDate);
                                }}
                                // filterDate={(date) => !isFutureDateDisabled(date)} // Disable future dates
                                className="form-control"
                            />
                        </div>
                        <div className="col-md-6 pl07">
                            <label className="col-form-label">
                                To Date:
                                <span style={{ color: "red" }}>{errorMessages.toDate}</span>
                            </label>
                            <DatePicker
                                placeholderText="DD-MM-YYYY"

                                value={toDate ? moment(toDate).format("DD-MM-YYYY") : null}
                                onChange={(date) => {
                                    const formattedToDate = moment(date).format("YYYY-MM-DD");
                                    setToDate(formattedToDate);
                                    calculateTotalDays(fromDate, formattedToDate);
                                    // alert(date)

                                }}
                                // filterDate={(date) => !isFutureDateDisabled(date)} // Disable future dates
                                filterDate={filterToDate}
                                className="form-control"
                            />
                        </div>
                    </div>
                    <label className="totalnumber">
                        Total Number of days - <span style={{ color: "red" }}>{dateSelect}</span>
                    </label>
                </div>
                <div className="mb-2">
                    <label className="col-form-label">
                        Duration:
                        <span style={{ color: "red" }}>{errorMessages.duration}</span>
                    </label>
                    <select
                        value={duration}
                        onChange={handleDuration}
                        className="form-select mb08"
                    >
                        <option value="">Select Duration</option>
                        <option value="1">Full Day</option>
                        {dateSelect === 1 || duration === 1 ? <option value="2">Half Day</option> : ""}
                    </select>
                </div>

                {duration === "2" && (
                    <div className="mb-2">
                        <label className="col-form-label">
                            Half Duration:
                            <span style={{ color: "red" }}>{errorMessages.halfDay}</span>
                        </label>
                        <select
                            value={halfDay}
                            onChange={(e) => setHalfDay(e.target.value)}
                            className="form-select"
                        >
                            <option value="">Select Half Day</option>
                            <option value="1">First Half</option>
                            <option value="2">Second Half</option>
                        </select>
                    </div>
                )}
                <div className="mb-2">
                    <label className="col-form-label">
                        Reason:
                        <span style={{ color: "red" }}>{errorMessages.reason}</span>
                    </label>
                    <textarea
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        className="form-control"
                        rows="2"
                    ></textarea>
                </div>

                <div className="modalfooter">
                    <span className="text-right mb10 d-block" style={{ color: "red" }}>
                        {isSubmitting && successMsg}
                    </span>
                    <div className="row">
                        <div className="col-md-6 pr07">
                            <button
                                type="button"
                                disabled={isSubmitting}
                                onClick={handleSubmit}
                                className={`btn_5 w-100 ${btnDisable === true ? 'disablebtn' : ''}`}
                            >
                                Submit
                            </button>
                        </div>
                        <div className="col-md-6 pl07">
                            <button
                                type="button"
                                onClick={handleClose2}
                                className="btn_6 w-100"
                                data-bs-dismiss="modal"
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default LeaveModal;
